module.exports = __webpack_public_path__ + "img/search_main.a37bc931.svg";